module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }